import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Crown, Check } from 'lucide-react';
export function FinalCTA() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-black via-amber-950/20 to-black overflow-hidden" data-id="element-908">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-black to-black" data-id="element-909" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-910">
        <div className="mb-8 sm:mb-10 flex justify-center" data-id="element-911">
          <Crown className="w-12 h-12 sm:w-16 sm:h-16 text-amber-500" data-id="element-912" />
        </div>

        <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 40px rgba(217, 119, 6, 0.4)'
      }} data-id="element-913">
          Join The Private Research Order
        </h2>

        <p className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-4 sm:mb-6 max-w-2xl mx-auto italic" data-id="element-914">
          From the Authors of Peptide Salvation
        </p>
        <div className="mb-10 sm:mb-12 max-w-2xl mx-auto space-y-2" data-id="element-915">
          <p className="text-base sm:text-lg text-amber-300 font-semibold" data-id="element-916">
            Brenden Henry — World's #1 Authority on Peptide Science
          </p>
          <p className="text-base sm:text-lg text-emerald-300 font-semibold" data-id="element-917">
            Dr. Ali Mazloum — The Biomedical Genius Known as The Human MRI
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-12 sm:mb-16" data-id="element-918">
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-919">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-920" />
            <span data-id="element-921">Instant Access</span>
          </div>
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-922">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-923" />
            <span data-id="element-924">Secure Payment</span>
          </div>
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-925">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-926" />
            <span data-id="element-927">Lifetime Updates</span>
          </div>
        </div>

        <button onClick={() => {
        const pricingSection = document.querySelector('[data-pricing-section]');
        if (pricingSection) {
          pricingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }} className="inline-block w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_30px_rgba(217,119,6,0.4)] hover:shadow-[0_0_60px_rgba(217,119,6,0.6)] hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-928">
          Join the Private Research Order Now
        </button>

        <p className="mt-6 sm:mt-8 text-stone-500 text-sm sm:text-base" data-id="element-929">
          Enrollment closes Saturday, March 28th at 11:59 PM ET
        </p>
      </motion.div>
    </section>;
}